import { useEffect } from 'react';
import { openLanding } from '../utils/landing';
import { PRO_PRICE_TEXT, PRO_PRICE_SHORT, PLUSZ_PRICE_TEXT, PLUSZ_PATH } from '../utils/pricing';
import { trackPaywall } from '../utils/access';
import { exportLocalData } from './LocalStatusBar';
import './TrialEndedModal.css';
import { TAG_LESSONS } from '../utils/leckeszam';

/* Shown ONCE (localStorage flag, see App.js) on the first visit after the
   PRO trial ended. Since the reverse trial the terminal no longer
   locks: the user keeps the free part, so this is a dismissible notice,
   not a wall. */

function readList(base) {
  const email = localStorage.getItem('terminal_email') || '';
  try {
    const v = JSON.parse(localStorage.getItem(email ? `${base}_${email}` : base));
    return Array.isArray(v) ? v.length : 0;
  } catch { return 0; }
}

export function localDataSummary() {
  const parts = [];
  const wl = readList('local_watchlist');
  const plans = readList('local_tradelog');
  const pos = readList('local_portfolio');
  if (wl) parts.push(`${wl} coin a figyelőlistádon`);
  if (plans) parts.push(`${plans} terv a Tervezőben`);
  if (pos) parts.push(`${pos} pozíció a Portfólióban`);
  return parts.join(', ');
}

export default function TrialEndedModal({ user, access, onClose, onTagClick, showPlusz = true }) {
  const summary = localDataSummary();

  useEffect(() => {
    trackPaywall('trial_expired_modal_view', { tier: access?.tier || null }, user);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="trial-overlay" role="dialog" aria-modal="true" aria-labelledby="trial-ended-title">
      <div className="trial-card">
        <button className="trial-close" aria-label="Bezárás" onClick={onClose}>✕</button>
        <h2 id="trial-ended-title" className="trial-title">Lejárt a PRO-próbád</h2>
        <p className="trial-subtitle">
          {showPlusz
            ? 'A terminál ingyenes része továbbra is a tiéd: Dashboard, Kalkulátor, Trade Tervező, Portfólió, Naptár, valamint a BTC és ETH derivatíva-adatai. Ami az eszközödön van, megmaradt.'
            : 'A Plusz-előfizetésed része továbbra is a tiéd: Szkenner, RSI-áttekintés, Funding, a top 200-as hőtérkép és 22 coin derivatíva-adatai. Ami az eszközödön van, megmaradt.'}
        </p>
        {summary && <p className="trial-local-summary">{summary}.</p>}

        {/* Első ajánlat a Plusz (a Plusz-előfizetőnek csak a PRO), második a PRO. */}
        <div className="trial-block-actions">
          {/* A Plusz a fő ajánlat (kitöltött), a PRO körvonalas, lila másodlagos; az ár a gomb alatt. */}
          {showPlusz && (
            <div className="trial-offer">
              <button
                className="trial-btn trial-btn-plusz trial-btn-primary"
                onClick={() => openLanding(PLUSZ_PATH, {
                  user,
                  event: 'plusz_cta_click',
                  eventProps: { hely: 'terminal_probaveg' },
                })}
              >
                Plusszal folytatom
              </button>
              <span className="trial-offer-price">{PLUSZ_PRICE_TEXT}</span>
            </div>
          )}
          <div className="trial-offer">
            <button
              className={`trial-btn trial-btn-pro-outline${showPlusz ? '' : ' trial-btn-primary'}`}
              onClick={() => openLanding('/pro', {
                user,
                event: 'pro_cta_clicked',
                eventProps: { source: 'modal', tier: access?.tier || null },
              })}
            >
              PRO részletek
            </button>
            <span className="trial-offer-price">{showPlusz ? PRO_PRICE_SHORT : PRO_PRICE_TEXT}</span>
          </div>
          <button className="trial-btn trial-btn-ghost" onClick={onClose}>
            Folytatás ingyenesen
          </button>
        </div>

        <div className="trial-exit-links">
          <button className="trial-link-btn" onClick={exportLocalData}>⬆ Adataim exportálása</button>
          {onTagClick && (
            <>
              <span className="trial-exit-sep">·</span>
              <button className="trial-link-btn" onClick={onTagClick}>TAG · {TAG_LESSONS} lecke ingyen →</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
